import objectFitImages from 'object-fit-images';
import 'objectFitPolyfill';

let windowHeight = $(window).height(),
  windowWidth = $(window).width();

const mediaSM = 768,
  mediaMD = 992,
  mediaLG = 1200,
  mediaXLG = 1600;

const screenXS = function() {
  let $width = $(window).width();
  return ($width < mediaSM ? true : false);
};
const screenSM = function() {
  let $width = $(window).width();
  return ($width >= mediaSM ? true : false);
};
const screenMD = function() {
  let $width = $(window).width();
  return ($width >= mediaMD ? true : false);
};
const screenLG = function() {
  let $width = $(window).width();
  return ($width >= mediaLG ? true : false);
};
const screenXLG = function() {
  let $width = $(window).width();
  return ($width >= mediaXLG ? true : false);
};

const elemOffsetBottom = function(elem) {
  let eTop = $(elem).offset().top,
    eTopWindow = eTop - $(window).scrollTop(),
    eBottomWindow = -(eTopWindow - windowHeight);

  return eBottomWindow;
};

// MESSAGE CONTAINER
$(document).on('click', '#messageContainer a.close, #messageContainer .cover', function(e) {
  // if (e.target !== this)
  //   return;
  let t = $('#messageContainer > div');
  t.fadeOut(function() {
    t.remove();
  });
  return false;
});

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
  }
  return "";
}

//COOKIE
function closeInfo(item, cookieName) {
  function cookieInfoCheck() {
    $(item).slideUp();

    let exdate = new Date();
    exdate.setTime(exdate.getTime() + 60 * 60 * 24 * 365 * 1000);
    document.cookie = cookieName + '=1' + "; expires=" + exdate.toGMTString() + "; path=/";
  }

  $(item + ' .close').on('click', function(event) {
    event.preventDefault();

    cookieInfoCheck();
  });
}

//typographer_orphan
function orphan(items) {
  let timer;

  function init() {
    $(items).typographer_orphan({
      forbidden: ["a", "i", "o", "u", "w", "z", "ze"]
    });
  }

  let refresh = function() {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(init, 100);
  };

  $(window).on('resize', function() {
    refresh();
  });

  init();
}

//scrollTo
function scrollToHref(link) {
  $(link).on('click', function(e) {
    e.preventDefault();

    let target = $(link).attr('href');

    $(window).scrollTo(target, 400);
  });
}

function scrollToNext(link) {
  $(link).on('click', function(e) {
    e.preventDefault();

    let $target = $(this).parent().nextAll('.section');

    $(window).scrollTo($target, 400);
  });
}

function scrollToTop(link) {
  $(link).on('click', function(e) {
    e.preventDefault();

    let $target = 0;

    $(window).scrollTo($target, 400);
  });
}

//onlyNumbers
function onlyNumbers(input) {
  $(input).on({
    'keypress': function(evt) {
      var charCode = (evt.which) ? evt.which : event.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    }
  });
}

function getGeoLocation(){
    if(navigator.geolocation)
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    else
        alert('u ciebie nie działa');
}

function successCallback(position) {
    if($('#geoDepartmentContact').length)
        xajax_exe('PageModule-xajaxGeoDepartment', 'geoDepartmentContact', position.coords.latitude, position.coords.longitude);
}

function errorCallback(error) {
    switch(error.code) {
        case error.PERMISSION_DENIED:
            alert("User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            alert("Location information is unavailable.");
            break;
        case error.TIMEOUT:
            alert("The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            alert("An unknown error occurred.");
            break;
    }
}

$(function() {
  closeInfo('#cookieInfoFooter', 'cmsCookieInfoCheck');
  closeInfo('#clockInfoFooter', 'cmsClockInfoCheck');

  if (getCookie('cmsClockInfoCheck') != 1) {
    $('#clockInfoFooter').show();
  }

  if (getCookie('cookieInfoFooter') != 1) {
    $('#cookieInfoFooter').show();
  }  

  orphan('p, .heading, .subheading, .orphan');

  //progress circle animation
  // var path = document.querySelector('#circle11');
  // var length = path.getTotalLength();
  // console.log(length);

  if (typeof appear === "function") {
    let progressCircle = $('.progress');
  
    progressCircle.appear();
  
    progressCircle.on('appear', function(event, $all_appeared_elements) {
      let $this = $(this);
  
      $this.find('.path-1').addClass('in');
      $this.find('.progress__value').count();
    });    
  }

  //checkbox
  $('input, label').mouseup(function() {
    $(this).closest('label').blur();
  });

  //fancyBoxPlus
  let fancy = {
    init: function() {
      $(".fancyplus").fancyboxPlus({
        'padding': 0,
        'margin': 20,
        'hideOnContentClick': true
      });
    }
  };

  fancy.init();

  // x-ms-format-detection
  $('body').attr('x-ms-format-detection', 'none');

  // selectric - custom select
  const Selectric = $('select.select-selectric').selectric({
    nativeOnMobile: false,
    onInit: function() {
      $('.selectric-items li[data-index="0"]').hide();
    }
  });

  //jQuery custom content scroller
  $(window).on("load", function() {
    $(".scroll").mCustomScrollbar({
      theme: "red"
    });

    $(".scroll-y").mCustomScrollbar({
      theme: "red",
      axis: "y"
    });

    if ($(window).width() >= 768) {
      $(".scroll-lg").mCustomScrollbar({
        theme: "red",
        axis: "x"
      });  
    }

    // if ($(window).width() < 768) {
    //   $(".scroll-xs").mCustomScrollbar({
    //     theme: "red",
    //     axis: "x"
    //   });
    // }    

    $('.scroll').hover(function () {
        $.fn.fullpage.setAllowScrolling(false);        
      }, function () {
        $.fn.fullpage.setAllowScrolling(true);
      }
    );

  });

  $("a[href^='tel:']").each(function() {
    let link = this;

    // replace tel with callto on desktop browsers for skype fallback					
    if (/Android|BlackBerry|iPhone|iPad|iPod|webOS/i.test(navigator.userAgent) === false) {
      link.href = link.href.replace(/^tel:/, "callto:");
    }
  });

  //gallery
  $('.gallery').slick({
    dots: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: mediaSM,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }]
  });

  // const mainMinHeight = ( () => {
  //   let timer;

  //   let init = () => {
  //     let headerHeight = $('body > header').outerHeight(true) || 0,
  //       breadcrumbsHeight = $('.breadcrumbs').outerHeight(true) || 0,
  //       bannerHeight = $('.banner').outerHeight(true) || 0,
  //       footerHeight = $('body > footer').outerHeight(true) || 0,
  //       windowHeight = $(window).height();

  //     $('.article-wrapper').css('min-height', windowHeight - headerHeight - breadcrumbsHeight - bannerHeight - footerHeight - 30);

  //     // $('#main > .wrapper').css({
  //     //   'height': windowHeight - headerHeight - footerHeight,
  //     //   'top': headerHeight
  //     // });
  //   }

  //   let refresh = () => {
  //     if (timer) {
  //       clearTimeout(timer);
  //     }
  //     timer = setTimeout(init, 500);
  //   };

  //   $(window).resize(function() {
  //     refresh();
  //   });

  //   if ($(window).width() > 768) {
  //     init();
  //   }
  // })();


  // --------------------
  //      AJAX
  // --------------------

  let doc = $(document);

  doc.ajaxStart(function(event, jqXHR, options) {

    var preloader = $("#preloader");

    if (!preloader.length) {
      preloader = $("<div></div>", {
        "id": "preloader",
        "class": "preloader"
      }).hide().appendTo("body");
    }

    $("#preloader").fadeIn(500);

  });

  doc.ajaxComplete(function() {

    $("#preloader").fadeOut(500);

  });

  objectFitImages('img.object-fit');
  objectFitPolyfill();

  if($('#geoDepartmentContact').length)
      getGeoLocation();

  $('#searchCatMenu .item').on('click tap', function(e){
        e.preventDefault();
        $('input:text').each(function( index ){
            $(this).val($(this).data('default'));
        });
        $('input:checkbox').each(function( index ){
            if($(this).data('default') == 1)
                $(this).prop('checked', true);
            else
                $(this).prop('checked', false);
        });
        $('#searchForm').attr('action', $(this).attr('href')).submit();
  });

  $('#tagList .tag').on('click', function() {
        $('#formTag input[name="s_tagid"]').val($(this).data('tagid'));
        $('#formTag').submit();
  });
});

export {
  mediaSM,
  mediaMD,
  mediaLG,
  mediaXLG,
  elemOffsetBottom,
  onlyNumbers,
  scrollToHref,
  scrollToNext,
  scrollToTop
}


// WEBPACK FOOTER //
// ./src/js/components/common.js